import { Pipe, PipeTransform } from '@angular/core';
import {SpecLineModel} from "web-shared";

@Pipe({
  name: 'isSpecWithLocalizations'
})
export class IsSpecWithLocalizationsPipe implements PipeTransform {

  transform(spec: SpecLineModel, specLineModels: SpecLineModel[]): boolean {
    return specLineModels.filter(line => line.PropertyId === spec.PropertyId && line.Id !== spec.Id && line.LanguageId !== null).length > 0;
  }

}
